export const switchTheme = {
  baseStyle: {
    track: {
      _checked: {
        bg: 'blue.700',
      },
    },
  },
}
